<template>
  <div class="contact-us-wrapper">
    <el-dialog
      v-if="modal"
      :visible.sync="this.$store.state.contactUs.contactUsStatus"
      :before-close="handleClose"
      title="Contact Us"
      class="contact-us-inner">
      <el-form
        ref="contactUs"
        :rules="rules"
        :model="contactUs">
        <el-row :gutter="20">
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24">
            <el-form-item prop="name">
              <label for="name">Name*</label>
              <el-input
                v-model="contactUs.name"
                name="name"
                placeholder="Name*" />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12">
            <el-form-item prop="phone">
              <label for="phone">Phone Number*</label>
              <el-input
                v-model="contactUs.phone"
                name="phone"
                placeholder="Phone Number*" />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12">
            <el-form-item prop="email">
              <label for="email">Email Address*</label>
              <el-input
                v-model="contactUs.email"
                name="email"
                placeholder="Email Address*" />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12">
            <el-form-item prop="services">
              <label for="services">Services*</label>
              <el-select
                v-model="contactUs.services"
                placeholder="Services*"
                multiple>
                <el-option
                  v-for="service in servicesList"
                  :key="service.value"
                  :label="service.label"
                  :value="service.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12">
            <el-form-item prop="contactTime">
              <label for="contactTime">Contact Time*</label>
              <el-select
                v-model="contactUs.contactTime"
                placeholder="Contact Time*"
                multiple>
                <el-option
                  v-for="time in contactTimeList"
                  :key="time.value"
                  :label="time.label"
                  :value="time.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item prop="message">
              <label for="message">Message</label>
              <el-input
                :rows="4"
                v-model="contactUs.message"
                type="textarea"
                placeholder="Message" />
            </el-form-item>
            <el-form-item
              class="respond-asap"
              prop="respond">
              <label for="respond">respond*</label>
              <el-input
                v-model="contactUs.honeyPot"
                name="respond"
                placeholder="respond*" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          plain
          type="danger"
          @click="handleCancel">Cancel</el-button>
        <el-button
          plain
          type="success"
          @click="handleSubmit">Submit</el-button>
      </span>
    </el-dialog>
    <div v-else>
      <div v-if="!formComplete">
        <el-form
          ref="contactUs"
          :rules="rules"
          :model="contactUs">
          <el-row :gutter="20">
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              :xl="24">
              <el-form-item prop="name">
                <label for="name">Name*</label>
                <el-input
                  v-model="contactUs.name"
                  name="name"
                  placeholder="Name*" />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12">
              <el-form-item prop="phone">
                <label for="phone">Phone Number*</label>
                <el-input
                  v-model="contactUs.phone"
                  name="phone"
                  placeholder="Phone Number*" />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12">
              <el-form-item prop="email">
                <label for="email">Email Address*</label>
                <el-input
                  v-model="contactUs.email"
                  name="email"
                  placeholder="Email Address*" />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="12"
              :lg="12"
              :xl="12">
              <el-form-item prop="services">
                <label for="services">Services*</label>
                <el-select
                  v-model="contactUs.services"
                  placeholder="Services*"
                  multiple>
                  <el-option
                    v-for="service in servicesList"
                    :key="service.value"
                    :label="service.label"
                    :value="service.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="12"
              :lg="12"
              :xl="12">
              <el-form-item prop="contactTime">
                <label for="contactTime">Contact Time*</label>
                <el-select
                  v-model="contactUs.contactTime"
                  placeholder="Contact Time*"
                  multiple>
                  <el-option
                    v-for="time in contactTimeList"
                    :key="time.value"
                    :label="time.label"
                    :value="time.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24">
              <el-form-item prop="message">
                <label for="message">Message</label>
                <el-input
                  :rows="4"
                  v-model="contactUs.message"
                  type="textarea"
                  placeholder="Message" />
              </el-form-item>
              <el-form-item
                class="respond-asap"
                prop="respond">
                <label for="respond">respond*</label>
                <el-input
                  v-model="contactUs.honeyPot"
                  name="respond"
                  placeholder="respond*" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer">
          <el-button
            v-if="modal"
            plain
            type="danger"
            @click="handleCancel">Cancel</el-button>
          <el-button
            plain
            type="success"
            @click="handleSubmit">Submit</el-button>
        </span>
      </div>
      <div v-else>
        <hr >
        <h3>Thank you for reaching out to us!</h3>
        <p>Thank you for reaching out to us! We will look over your information and a member of our team will reach back out you as soon as possible. In the meantime, feel free to check our site out to for more information.</p>
        <p>Thanks again for considering Ingalls Image for any and all of your media needs,</p>
        <p>~The Ingalls Image Team</p>
        <router-link
          :to="{ name: 'home.index' }">
          <el-button
            plain
            type="primary">Return Home</el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
const email = require('@/emailConfig/');

export default {
  props: {
    modal: {
      require: false,
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formComplete: false,
      honeyPot: false,
      honeyPotTimer: false,
      servicesList: [
        {
          value: 'Digital Media',
          label: 'Digital Media',
        },
        {
          value: 'Physical Media',
          label: 'Physical Media',
        },
        {
          value: 'Social Media',
          label: 'Social Media',
        },
      ],
      contactTimeList: [
        {
          value: 'Morning (9am - 12pm)',
          label: 'Morning (9am - 12pm)',
        },
        {
          value: 'Afternoon (12pm - 4pm)',
          label: 'Afternoon (12pm - 4pm)',
        },
        {
          value: 'Evening (4pm - 8pm)',
          label: 'Evening (4pm - 8pm)',
        },
      ],
      contactUs: {
        name: null,
        phone: null,
        email: null,
        preferredMethod: null,
        services: [],
        contactTime: [],
        message: null,
        honeyPot: null,
      },
    };
  },
  computed: {
    rules() {
      return {
        name: [{
          required: true,
          message: 'Please provide your name',
          trigger: 'blur',
        }],
        phone: [{
          required: this.phoneORemail('phone'),
          message: 'Please enter either a phone or email',
          trigger: 'blur',
        },
        {
          pattern: /\D*([2-9]\d{2})(\D*)([2-9]\d{2})(\D*)(\d{4})\D*/,
          message: 'Please enter a valid phone number',
          trigger: 'blur',
        },
        ],
        email: [{
          required: this.phoneORemail('email'),
          message: 'Please enter either a phone or email',
          trigger: 'blur',
        },
        {
          pattern: /[^@]+@[^.]+\..+/,
          message: 'Please enter a valid email',
          trigger: 'blur',
        },
        ],
        services: [{
          required: true,
          message: 'Please select one or more services',
          trigger: 'change',
        }],
        contactTime: [{
          required: true,
          message: 'Please select one or more times',
          trigger: 'change',
        }],
      };
    },
  },
  updated() {
    this.honeyPotCount();
  },
  beforeDestroy() {
    if (!this.modal) {
      this.formComplete = false;
    }
  },
  methods: {
    formCleanup() {
      this.$store.dispatch('contactUs/toggle', false);
      this.$refs.contactUs.resetFields();
      this.$refs.contactUs.clearValidate();
    },
    phoneORemail(field) {
      if (field === 'phone') {
        const emailVal = this.contactUs.email;

        if (emailVal === null) {
          return true;
        }
        return false;
      } else if (field === 'email') {
        const phoneVal = this.contactUs.phone;

        if (phoneVal === null) {
          return true;
        }
        return false;
      }
    },
    handleSubmit() {
      this.$refs.contactUs.validate((valid) => {
        if (valid) {
          if (this.honeyPot || !this.contactUs.honeyPot) {
            const emailPackage = {
              emailType: 1,
              emailData: this.contactUs,
            };
            email.emailControl(emailPackage);
            if (this.modal) {
              this.$message({
                message: 'Thank you for reaching out to us!  We will respond ASAP',
                type: 'success',
              });
            } else {
              this.formComplete = true;
            }
            this.formCleanup();
          } else {
            this.$message({
              message: 'Im sorry, there was a problem submitting.  Please try again',
              type: 'error',
            });
          }
        } else {
          this.$message({
            message: 'Please fill out all required fields',
            type: 'warning',
          });
        }
      });
    },
    handleCancel() {
      this.formCleanup();
    },
    handleClose() {
      this.formCleanup();
    },
    honeyPotCount() {
      const self = this;
      let timeLeft = 10;
      if (!this.honeyPotTimer) {
        const honeyPotTimer = setInterval(() => {
          this.honeyPotTimer = true;
          timeLeft -= 1;
          if (timeLeft === 0) {
            self.honeyPot = true;
            clearInterval(honeyPotTimer);
          }
        }, 1000);
      }
    },
  },
};
</script>
